import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

// Import only the FontAwesome solid icons actually used in <fa-icon> tags
import {
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faBox,
  faCalendarAlt,
  faCalendarCheck,
  faCaretDown,
  faCaretRight,
  faCheck,
  faCheckCircle,
  faClipboard,
  faComment,
  faComments,
  faCompress,
  faCubes,
  faDirections,
  faDrawPolygon,
  faDrumstickBite,
  faExclamationTriangle,
  faExpand,
  faExpandArrowsAlt,
  faEye,
  faEyeSlash,
  faFilePdf,
  faGripLines,
  faHandsHelping,
  faHistory,
  faImage,
  faInfoCircle,
  faKey,
  faLightbulb,
  faList,
  faListAlt,
  faLock,
  faMap,
  faMapMarkerAlt,
  faMinus,
  faMinusSquare,
  faMobileAlt,
  faMinusCircle,
  faPaw,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPencilAlt,
  faPencilRuler,
  faProjectDiagram,
  faQuestionCircle,
  faRedo,
  faRedoAlt,
  faRetweet,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faSortAmountDown,
  faSortAmountDownAlt,
  faStickyNote,
  faStopwatch,
  faStreetView,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTrashAlt,
  faUser,
  faUserCog,
  faUserEdit,
  faUserPlus,
  faUserShield,
  faVideo,
  // Navigation service icons (used via dynamic icon lookup)
  faHome,
  faEdit,
  faClipboardList,
  faCube,
  faChartBar,
  faFilm,
  faCogs,
  faEnvelope,
  faTable,
  faFileDownload,
  faWrench,
  // Admin navigation icons
  faMapLocationDot,
  faRoute,
  faUsers,
  faFileCsv,
  faCog
} from '@fortawesome/free-solid-svg-icons';

// Import FontAwesome regular icons used with [icon]="['far', 'iconname']" syntax
import {
  faCalendar,
  faCheckSquare,
  faSquare
} from '@fortawesome/free-regular-svg-icons';

/**
 * Centralized FontAwesome icon registry for the CatchIT application.
 *
 * NOTE: This only registers FontAwesome icons used in <fa-icon> tags.
 * Ionic icons used in <ion-icon> tags are handled automatically by Ionic
 * and do not need to be registered here.
 *
 * Only imports the icons actually used in the application for optimal bundle size.
 */
export function registerFontAwesomeIcons(library: FaIconLibrary): void {
  library.addIcons(
    // FontAwesome solid icons
    faArrowLeft,
    faArrowRight,
    faArrowsAlt,
    faBox,
    faCalendarAlt,
    faCalendarCheck,
    faCaretDown,
    faCaretRight,
    faCheck,
    faCheckCircle,
    faClipboard,
    faComment,
    faComments,
    faCompress,
    faCubes,
    faDirections,
    faDrawPolygon,
    faDrumstickBite,
    faExclamationTriangle,
    faExpand,
    faExpandArrowsAlt,
    faEye,
    faEyeSlash,
    faFilePdf,
    faGripLines,
    faHandsHelping,
    faHistory,
    faImage,
    faInfoCircle,
    faKey,
    faLightbulb,
    faList,
    faListAlt,
    faLock,
    faMap,
    faMapMarkerAlt,
    faMinus,
    faMinusSquare,
    faMobileAlt,
    faMinusCircle,
    faPaw,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faPencilAlt,
    faPencilRuler,
    faProjectDiagram,
    faQuestionCircle,
    faRedo,
    faRedoAlt,
    faRetweet,
    faSignInAlt,
    faSignOutAlt,
    faSort,
    faSortAlphaDown,
    faSortAlphaDownAlt,
    faSortAmountDown,
    faSortAmountDownAlt,
    faStickyNote,
    faStopwatch,
    faStreetView,
    faThumbtack,
    faTimes,
    faTimesCircle,
    faToggleOff,
    faToggleOn,
    faTrashAlt,
    faUser,
    faUserCog,
    faUserEdit,
    faUserPlus,
    faUserShield,
    faVideo,
    faHome,
    faEdit,
    faClipboardList,
    faCube,
    faChartBar,
    faFilm,
    faCogs,
    faEnvelope,
    faTable,
    faFileDownload,
    faWrench,
    // Admin navigation icons
    faMapLocationDot,
    faRoute,
    faUsers,
    faFileCsv,
    faCog,
    // FontAwesome regular icons
    faCalendar,
    faCheckSquare,
    faSquare
  );
}